import { DecimalSchema } from "../decimal";
import { NON_ELIGIBILITY_REASONS, ORDER_STATUS, ORDER_SIDE, ORDER_TYPE } from "../shared";
import { z } from "zod";

export const CampaignOrderSchema = z.object({
  id: z.number(),
  createdAt: z.coerce.date(),
  defiAddress: z.string(),
  campaignId: z.string().optional(),
  externalOrderId: z.string(),
  exchangeId: z.string(),
  exchangeUserId: z.string(),
  status: z.nativeEnum(ORDER_STATUS),
  pairSymbol: z.string(),
  amount: DecimalSchema,
  filled: DecimalSchema,
  filledQuote: DecimalSchema,
  type: z.nativeEnum(ORDER_TYPE),
  price: DecimalSchema,
  side: z.nativeEnum(ORDER_SIDE),
  antiBotVerified: z.boolean().optional(),
  stpGroupId: z.string().optional(),
  originIpHash: z.string().optional(),
  orderTradeIds: z.array(z.string()).optional(),
  isEligibleToRewards: z.boolean(),
  nonEligibilityReason: z.nativeEnum(NON_ELIGIBILITY_REASONS).optional(),
});

export type CampaignOrder = z.infer<typeof CampaignOrderSchema>;

export const CampaignOrderArraySchema = z.array(CampaignOrderSchema);
export type CampaignOrderArray = z.infer<typeof CampaignOrderArraySchema>;
